// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__EQtlF","inner":"footer_inner__3b0nN","legalLinks":"footer_legalLinks__1jlMn","button":"footer_button__Tjgy3","statusBar":"footer_statusBar__1YL8o"};